import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
@Component({
  selector: 'app-schedule-job-modal-popup',
  templateUrl: './schedule-job-modal-popup.component.html',
  styleUrls: ['./schedule-job-modal-popup.component.scss']
})
export class ScheduleJobModalPopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal, public service: ApifirstService) { }

  public sheduleJobPopupMessage = this.service.scheduleJobStatusMessage.getValue();

  ngOnInit(): void {
  }

}
